import { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import { get } from "../../../api";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const currentTime = new Date();
  const currentTimev2 = currentTime.getTime();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [availablePasses, setAvailablePasses] = useState<Ticket[]>([]);

  const getAvailablePasses = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setAvailablePasses(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAvailablePasses();
    //eslint-disable-next-line
  }, []);

  return {
    currentTimev2,
    loading,
    availablePasses,
  };
};
